import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/colors.css";
import "./styles/Global.css";
import App from "./App";
import { CartProvider } from "./Context/CartContext";
import { BrowserRouter as Router } from "react-router-dom";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

if (process.env.NODE_ENV === "production") disableReactDevTools();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <CartProvider>
      <App />
    </CartProvider>
  </Router>,
);
